import { TMobileModes } from '@shared/types/frontend';
import { useLocalStorage } from 'usehooks-ts';
import { TAllowedCurrencies } from '../admin/useAppSettings';
export default function useAppDetails() {
  const [isNativeApp, setIsNativeApp] = useLocalStorage('isNativeApp', false);
  const [isAppleNativeApp, setIsAppleNativeApp] = useLocalStorage('isAppleNativeApp', false);
  const [isGoogleNativeApp, setIsGoogleNativeApp] = useLocalStorage('isGoogleNativeApp', false);
  const [referralUrlCode, setReferralUrlCode] = useLocalStorage('referral-code', '');
  const [blockApp, setBlockApp] = useLocalStorage('blockApp', false);
  const [blockAppVersion, setBlockAppVersion] = useLocalStorage('blockAppVersion', false);
  const [mobileMode, setMobileMode] = useLocalStorage<TMobileModes>('mobileMode', 'home');
  const [mobileModeMetadata, setMobileModeMetadata] = useLocalStorage<{
    // can use for other metadata as well later
    networkId: string | number;
    address: string;
    prev_m_mode?: string;
    fromUnverified?: boolean;
  } | null>('mobileModeMetadata', null);
  const [showUnverifiedWarning, setShowUnverifiedWarning] = useLocalStorage('showUnverifiedWarning', true);
  const [appVersion, setAppVersion] = useLocalStorage<{
    id: string;
    name: string;
    version: string;
    buildNumber: string;
  }>('app_version', {
    id: '',
    name: '',
    version: '',
    buildNumber: ''
  });
  const [depositCurrencyOverride, setDepositCurrencyOverride] = useLocalStorage<TAllowedCurrencies | null>('depositOverride', null);
  return {
    isNativeApp,
    setIsNativeApp,
    isAppleNativeApp,
    setIsAppleNativeApp,
    isGoogleNativeApp,
    setIsGoogleNativeApp,
    referralUrlCode,
    setReferralUrlCode,
    blockApp,
    setBlockApp,
    blockAppVersion,
    setBlockAppVersion,
    mobileMode,
    setMobileMode,
    mobileModeMetadata,
    setMobileModeMetadata,
    showUnverifiedWarning,
    setShowUnverifiedWarning,
    appVersion,
    setAppVersion,
    depositCurrencyOverride,
    setDepositCurrencyOverride
  };
}